export default function SuitableCompanies() {
  const industries = [
    { icon: 'ri-briefcase-line', title: 'B2B', desc: 'Продажи сложных продуктов и услуг корпоративным клиентам с длинным циклом сделки' },
    { icon: 'ri-shopping-bag-3-line', title: 'B2C', desc: 'Розничные продажи, работа с конечным потребителем, быстрые транзакции' },
    { icon: 'ri-settings-3-line', title: 'Производство', desc: 'Продажи промышленного оборудования, сырья, комплектующих' },
    { icon: 'ri-service-line', title: 'Услуги', desc: 'Консалтинг, маркетинг, IT-услуги, логистика, финансовые услуги' },
    { icon: 'ri-code-s-slash-line', title: 'IT', desc: 'Продажа программных продуктов, SaaS, digital-услуг и технических решений' },
    { icon: 'ri-ship-line', title: 'Логистика', desc: 'Транспортные и складские услуги, международные и внутренние перевозки' },
    { icon: 'ri-building-line', title: 'Строительство', desc: 'Продажи строительных материалов, проектных работ, девелоперских услуг' },
    { icon: 'ri-heart-pulse-line', title: 'Медицина', desc: 'Медицинское оборудование, фармацевтика, частные клиники и лаборатории' },
    { icon: 'ri-store-2-line', title: 'Ритейл', desc: 'Розничные сети, интернет-магазины, оптово-розничная торговля' },
    { icon: 'ri-graduation-cap-line', title: 'Образование', desc: 'Продажа образовательных услуг, онлайн-курсов, корпоративных программ обучения' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Для каких компаний подходит <strong>тренинг по продажам</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            <strong>Корпоративное обучение продажам</strong> эффективно для бизнеса любого размера и отрасли. Программа адаптируется под специфику вашего продукта, цикла продаж и целевой аудитории.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {industries.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-5 hover:bg-teal-50 hover:shadow-md transition-all duration-300 group cursor-default text-center">
              <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center mx-auto mb-3 shadow-sm group-hover:bg-teal-600 transition-colors duration-300 flex-shrink-0">
                <i className={`${item.icon} text-xl text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-sm font-bold text-gray-900 mb-1">{item.title}</h3>
              <p className="text-xs text-gray-600 leading-snug">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}